/* eslint-disable complexity */
/* eslint-disable indent */
/* eslint-disable max-lines */
/* eslint-disable react/prop-types */
/* eslint-disable max-lines-per-function */
import {
    MerchantTab,
    IntegrationTab,
    PayModeTab,
    PGConfigTab,
    RoutingTab,
    SurchargeTab,
    NotificationTab,
    SettlementTab,
    KYCTab,
} from '../../components';
import {
    getTimelineStatus,
    createSurchargeOptions,
    getDynamicBoolValues,
    getDynamicBoolFromArray,
    getBusinessSources,
    getBusinessSourcesToAccountTypeMapping,
} from '../../utils/helperMethods';
import React from 'react';
import { orderBy, first } from 'lodash';

// Components

// Helpers

const baseUrl = '/mob/create/';

const formatPayModeInitialData = draftData => {
    if (draftData && draftData.data) {
        const paymentMode = draftData.data.paymentModeDetails || [];
        const creditCard = [];
        const debitCard = [];
        const netBanking = [];
        const upi = [];
        let debitCardBusinessSource = [];
        let creditCardBusinessSource = [];
        let upiBusinessSource = [];
        let upiAccountType = [];
        const wallets = [];
        const accountVerification = [];
        const emi = [];
        let emiBusinessSource = [];
        const mandateUpi = [];
       
        let vpa = '';
        paymentMode.forEach(item => {
            if (!item) {
                return;
            }
            if (item.paymentType === 'CC') {
                creditCard.push(item.paymentModeInfo);
                creditCardBusinessSource = item ? getBusinessSources(item) : [];
            }
            if (item.paymentType === 'DC') {
                debitCard.push(item.paymentModeInfo);
                debitCardBusinessSource = item ? getBusinessSources(item) : [];
            }
            if (item.paymentType === 'NB') {
                netBanking.push(item.paymentModeInfo);
            }
            if (item.paymentType === 'UPI' && item.category !== 'MANDATE') {
                upi.push(item.paymentModeInfo);
                vpa = item.paymentSubModeInfo;
                upiBusinessSource = item ? getBusinessSources(item) : [];

                upiAccountType = item.txnConfig
                    ? getBusinessSourcesToAccountTypeMapping(item.txnConfig)
                    : [];
            }

            if (item.paymentType === 'UPI' && item.category === 'MANDATE') {
                mandateUpi.push(item.paymentModeInfo);
            }

            if (item.paymentType === 'WALLET') {
                wallets.push(item.paymentModeInfo);
            }
            if (item.paymentType === 'ACCOUNT_VERIFICATION') {
                accountVerification.push(item.paymentModeInfo);
            }
            if (item.paymentType === 'EMI_CC') {
                emi.push(item.paymentModeInfo);
                emiBusinessSource = item ? getBusinessSources(item) : [];
            }
        });

        return {
            creditCard,
            debitCard,
            netBanking,
            upi,
            mandateUpi,
            debitCardBusinessSource,
            creditCardBusinessSource,
            upiBusinessSource,
            ...upiAccountType,
            wallets,
            accountVerification,
            emi,
            emiBusinessSource,
            paymentLinkEnabled: getDynamicBoolValues(
                draftData && draftData.data,
                'paymentLinkEnabled'
            ),
            paymentPageEnabled: getDynamicBoolValues(
                draftData && draftData.data,
                'paymentPageEnabled'
            ),
            voidCapability: getDynamicBoolValues(
                draftData && draftData.data,
                'voidCapability'
            ),
            emiEnabled: getDynamicBoolValues(
                draftData && draftData.data,
                'emiEnabled'
            ),
            vpa,
            isRefIdEnabled: draftData.data.isRefIdEnabled
                ? draftData.data.isRefIdEnabled
                : false,
            appId: draftData.data.appId,
        };
    }
    return {};
};
const getDefaultSecurityValue = securityValue => {
    if (securityValue) {
        const allSelectedValues = [];
        const values = securityValue;
        if (typeof values === 'string' || values instanceof String) {
            return values;
        }
        for (const property in values) {
            if (Object.prototype.hasOwnProperty.call(values, property)) {
                if (values[property]) {
                    allSelectedValues.push(property);
                }
            }
        }
        return first(allSelectedValues);
    }
    return '';
};

const formatIntegrationInitialData = draftData => {
    if (draftData && draftData.data) {
        const draftDataValue = { ...draftData.data };
        draftDataValue.security = getDefaultSecurityValue(
            draftDataValue.security
        );
        return draftDataValue;
    }
    return {};
};

/**
 * Function to generate an onboarding process configuration based on provided fields and data.
 *
 * @param {Array} fields - An array of field objects representing the onboarding steps.
 * @param {Object} draftData - Data related to the onboarding process.
 * @param {string} routePath - The current route path for the onboarding process.
 * @param {Object} permissions - Object to which user have permission to
 * @returns {Array} - An array of onboarding process steps with configurations.
 */
export const onboardingProcess = (
    fields,
    draftData,
    routePath,
    data,
    permissions = {}
) => {
    const merchantOnboardingPermissions = permissions.merchant_onboarding
        ? permissions.merchant_onboarding
        : [];

    // Define a list of onboarding process steps with their configurations.
    const processStepsList = [
        {
            component(props) {
                // eslint-disable-next-line react/prop-types
                const { draftData } = props;
                return (
                    <MerchantTab
                        {...props} // eslint-disable-next-line react/prop-types
                        isDraft={true}
                        initialValues={(draftData && draftData.data) || {}}
                    />
                );
            },
            name: 'Merchant',
            sectionType: 'createMerchantSection',
            nextPath: `${baseUrl}integration`,
            path: `${baseUrl}merchant`,
            previousPath: '/mob',
            status: getTimelineStatus(
                draftData,
                routePath,
                'createMerchantSection',
                `${baseUrl}merchant`
            ),
            tabId: 1,
            permission: 'create_merchant',
        },
        {
            component(props) {
                // eslint-disable-next-line react/prop-types
                const { draftData } = props;
                return (
                    <IntegrationTab
                        {...props} // eslint-disable-next-line react/prop-types
                        initialValues={formatIntegrationInitialData(draftData)}
                    />
                );
            },
            name: 'Integration',
            sectionType: 'integrationSection',
            nextPath: `${baseUrl}pay-mode`,
            path: `${baseUrl}integration`,
            previousPath: `${baseUrl}merchant`,
            status: getTimelineStatus(
                draftData,
                routePath,
                'integrationSection',
                `${baseUrl}integration`
            ),
            tabId: 2,
            permission: 'integration',
        },
        {
            component(props) {
                // eslint-disable-next-line react/prop-types
                const { draftData } = props;
                return (
                    <PayModeTab
                        {...props} // eslint-disable-next-line react/prop-types
                        initialValues={formatPayModeInitialData(draftData)}
                    />
                );
            },
            name: 'Payment Mode',
            sectionType: 'paymentModeSection',
            nextPath: `${baseUrl}settlement`,
            path: `${baseUrl}pay-mode`,
            previousPath: `${baseUrl}integration`,
            status: getTimelineStatus(
                draftData,
                routePath,
                'paymentModeSection',
                `${baseUrl}pay-mode`
            ),
            tabId: 3,
            permission: 'payment_mode',
        },
        {
            component(props) {
                // eslint-disable-next-line react/prop-types
                const { draftData } = props;
                return (
                    <SettlementTab
                        {...props} // eslint-disable-next-line react/prop-types
                        initialValues={(draftData && draftData.data) || {}}
                    />
                );
            },
            name: 'Settlement',
            sectionType: 'settlementSection',
            nextPath: `${baseUrl}pg-conf`,
            path: `${baseUrl}settlement`,
            previousPath: `${baseUrl}pay-mode`,
            status: getTimelineStatus(
                draftData,
                routePath,
                'settlementSection',
                `${baseUrl}settlement`
            ),
            tabId: 4,
            permission: 'settlement',
        },
        {
            component(props) {
                // eslint-disable-next-line react/prop-types
                const { draftData } = props;
                const { state } = draftData || {};
                return (
                    <SurchargeTab
                        {...props} // eslint-disable-next-line react/prop-types
                        initialValues={
                            (draftData &&
                                draftData.data &&
                                state !== 'Open' && {
                                    feeConfigList: createSurchargeOptions(
                                        draftData.data.feeConfigListMap,
                                        'draft'
                                    ).slabs,
                                }) || {
                                feeConfigList: data.surchargeOptions.slabs,
                            }
                        }
                    />
                );
            },
            name: 'Surcharge',
            sectionType: 'surchargeSection',
            nextPath: `${baseUrl}kyc`,
            path: `${baseUrl}surcharge`,
            previousPath: `${baseUrl}settlement`,
            status: getTimelineStatus(
                draftData,
                routePath,
                'surchargeSection',
                `${baseUrl}surcharge`
            ),
            tabId: 5,
            permission: 'surcharge',
        },
        {
            component(props) {
                // eslint-disable-next-line react/prop-types
                const { draftData } = props;
                return (
                    <KYCTab
                        {...props} // eslint-disable-next-line react/prop-types
                        initialValues={(draftData && draftData.data) || {}}
                    />
                );
            },
            name: 'Merchant Docs',
            sectionType: 'kycSection',
            nextPath: `${baseUrl}pg-conf`,
            path: `${baseUrl}kyc`,
            previousPath: `${baseUrl}surcharge`,
            status: getTimelineStatus(
                draftData,
                routePath,
                'kycSection',
                `${baseUrl}kyc`
            ),
            tabId: 6,
            permission: 'kyc',
        },
        {
            component(props) {
                // eslint-disable-next-line react/prop-types
                const { draftData } = props;
                return (
                    <PGConfigTab
                        {...props} // eslint-disable-next-line react/prop-types
                        initialValues={(draftData && draftData.data) || {}}
                    />
                );
            },
            name: 'PG Configuration',
            sectionType: 'pgConfigurationSection',
            nextPath: `${baseUrl}routing`,
            path: `${baseUrl}pg-conf`,
            previousPath: `${baseUrl}kyc`,
            status: getTimelineStatus(
                draftData,
                routePath,
                'pgConfigurationSection',
                `${baseUrl}pg-conf`
            ),
            tabId: 7,
            permission: 'pg_configuration',
        },

        {
            component(props) {
                // eslint-disable-next-line react/prop-types
                const { draftData } = props;
                return (
                    <RoutingTab
                        {...props} // eslint-disable-next-line react/prop-types
                        initialValues={
                            draftData && draftData.data
                                ? {
                                      ...draftData.data,
                                      enableDynamicRouting: getDynamicBoolValues(
                                          draftData && draftData.data,
                                          'enableDynamicRouting'
                                      ),
                                      pgRoutingRequestList: data.defaultRouting,
                                  }
                                : {
                                      enableDynamicRouting: getDynamicBoolValues(
                                          draftData && draftData.data,
                                          'enableDynamicRouting'
                                      ),
                                      pgRoutingRequestList: data.defaultRouting,
                                  }
                        }
                    />
                );
            },
            name: 'Routing',
            sectionType: 'dynamicRoutingSection',
            nextPath: `${baseUrl}notification`,
            path: `${baseUrl}routing`,
            previousPath: `${baseUrl}pg-conf`,
            status: getTimelineStatus(
                draftData,
                routePath,
                'dynamicRoutingSection',
                `${baseUrl}routing`
            ),
            tabId: 8,
            permission: 'dynamic_routing',
        },

        {
            component(props) {
                // eslint-disable-next-line react/prop-types
                const { draftData } = props;
                return (
                    <NotificationTab
                        {...props} // eslint-disable-next-line react/prop-types
                        initialValues={
                            (draftData && draftData.data) || {
                                emailList: [null],
                                mobileList: [null],
                            }
                        }
                    />
                );
            },
            name: 'Notification',
            sectionType: 'notificationSection',
            nextPath: null,
            path: `${baseUrl}notification`,
            previousPath: `${baseUrl}routing`,
            status: getTimelineStatus(
                draftData,
                routePath,
                'notificationSection',
                `${baseUrl}notification`
            ),
            tabId: 9,
            permission: 'notification',
        },
    ];

    const sortedField = orderBy(fields, ['order'], ['asc']).filter(
        field => field.mandatory
    );

    if (
        merchantOnboardingPermissions &&
        merchantOnboardingPermissions.length > 0
    ) {
        // eslint-disable-next-line array-callback-return
        let sortedFieldMapped = sortedField.map((item, index) => {
            const sectionData = processStepsList.find(
                section => section.sectionType === item.sectionType
            );
            if (
                sectionData &&
                merchantOnboardingPermissions?.includes(sectionData.permission)
            ) {
                if (sectionData.sectionType === item.sectionType) {
                    const previousIndex = index - 1;
                    const nextIndex = index + 1;
                    if (previousIndex >= 0) {
                        const previousSectionData =
                            processStepsList[previousIndex];
                        sectionData.previousPath = previousSectionData.path;
                    } else {
                        sectionData.nextPath = null;
                    }
                    if (nextIndex < sortedField.length && nextIndex >= 0) {
                        const nextSectionData = processStepsList[nextIndex];
                        if (nextSectionData) {
                            sectionData.nextPath = nextSectionData.path;
                        } else {
                            sectionData.nextPath = null;
                        }
                    } else {
                        sectionData.nextPath = null;
                    }
                }

                return { ...item, ...sectionData };
            }
        });

        sortedFieldMapped = sortedFieldMapped.filter(function(element) {
            return element !== undefined;
        });

        if (sortedFieldMapped && sortedFieldMapped.length > 0) {
            sortedFieldMapped[sortedFieldMapped.length - 1].nextPath = null;
        }

        return sortedFieldMapped;
    }
    return [];
};

const baseUrlEdit = '/mob/draft/';
const baseUrlView = '/mob/draft/view/';

export const onboardingProcessEdit = (
    fields,
    merchantId,
    isViewMode,
    permissions
) => {

    const merchantOnboardingPermissions =
    (permissions && permissions.edit_merchant_onboarding) 
        ? permissions.edit_merchant_onboarding
        : (permissions && permissions.merchant_onboarding) 
            ? permissions.merchant_onboarding 
            : [];

    const processStepsList = [
        {
            component(props) {
                // eslint-disable-next-line react/prop-types
                const { draftData } = props;
                return (
                    <MerchantTab
                        isEditMode={!isViewMode}
                        isViewMode={isViewMode}
                        {...props} // eslint-disable-next-line react/prop-types
                        initialValues={(draftData && draftData.data) || {}}
                    />
                );
            },
            name: 'Merchant',
            sectionType: 'createMerchantSection',
            path: `${
                isViewMode ? baseUrlView : baseUrlEdit
            }merchant/${merchantId}`,
            previousPath: '/mob',
            status: 'Complete',
            nextPath: `${
                isViewMode ? baseUrlView : baseUrlEdit
            }integration/${merchantId}`,
            tabId: 1,
            permission: 'edit_merchant,view_merchant,create_merchant',
        },
        
        {
            component(props) {
                // eslint-disable-next-line react/prop-types
                const { draftData } = props;
                return (
                    <IntegrationTab
                        isEditMode={!isViewMode}
                        isViewMode={isViewMode}
                        {...props} // eslint-disable-next-line react/prop-types
                        initialValues={formatIntegrationInitialData(draftData)}
                    />
                );
            },
            name: 'Integration',
            sectionType: 'integrationSection',
            path: `${
                isViewMode ? baseUrlView : baseUrlEdit
            }integration/${merchantId}`,
            previousPath: `${
                isViewMode ? baseUrlView : baseUrlEdit
            }merchant/${merchantId}`,
            status: 'Complete',
            nextPath: `${
                isViewMode ? baseUrlView : baseUrlEdit
            }pay-mode/${merchantId}`,
            tabId: 2,
            permission: 'edit_integration,view_integration,integration',
        },
        {
            component(props) {
                // eslint-disable-next-line react/prop-types
                const { draftData } = props;
                return (
                    <PayModeTab
                        isEditMode={!isViewMode}
                        isViewMode={isViewMode}
                        {...props} // eslint-disable-next-line react/prop-types
                        initialValues={formatPayModeInitialData(draftData)}
                    />
                );
            },
            name: 'Payment Mode',
            sectionType: 'paymentModeSection',
            path: `${
                isViewMode ? baseUrlView : baseUrlEdit
            }pay-mode/${merchantId}`,
            previousPath: `${
                isViewMode ? baseUrlView : baseUrlEdit
            }integration/${merchantId}`,
            status: 'Complete',
            nextPath: `${
                isViewMode ? baseUrlView : baseUrlEdit
            }settlement/${merchantId}`,
            tabId: 3,
            permission: 'edit_payment_mode,view_payment_mode,payment_mode',
        },
        {
            component(props) {
                // eslint-disable-next-line react/prop-types
                const { draftData } = props;
                return (
                    <SettlementTab
                        isEditMode={!isViewMode}
                        isViewMode={isViewMode}
                        {...props} // eslint-disable-next-line react/prop-types
                        initialValues={(draftData && draftData.data) || {}}
                    />
                );
            },
            name: 'Settlement',
            sectionType: 'settlementSection',
            path: `${
                isViewMode ? baseUrlView : baseUrlEdit
            }settlement/${merchantId}`,
            previousPath: '/pay-mode',
            status: 'Complete',
            nextPath: `${
                isViewMode ? baseUrlView : baseUrlEdit
            }surcharge/${merchantId}`,
            tabId: 4,
            permission: 'edit_settlement,view_settlement_view,settlement,',
        },
        {
            component(props) {
                // eslint-disable-next-line react/prop-types
                const { draftData } = props;
                return (
                    <SurchargeTab
                        isEditMode={!isViewMode}
                        isViewMode={isViewMode}
                        {...props} // eslint-disable-next-line react/prop-types
                        initialValues={(draftData && draftData.data) || {}}
                    />
                );
            },
            name: 'Surcharge',
            sectionType: 'surchargeSection',
            path: `${
                isViewMode ? baseUrlView : baseUrlEdit
            }surcharge/${merchantId}`,
            previousPath: `${
                isViewMode ? baseUrlView : baseUrlEdit
            }settlement/${merchantId}`,
            status: 'Complete',
            nextPath: `${
                isViewMode ? baseUrlView : baseUrlEdit
            }kyc/${merchantId}`,
            tabId: 5,
            permission: 'edit_surcharge,view_surcharge,surcharge',
        },
        {
            component(props) {
                // eslint-disable-next-line react/prop-types
                const { draftData } = props;
                return (
                    <KYCTab
                        isEditMode={!isViewMode}
                        isViewMode={isViewMode}
                        {...props} // eslint-disable-next-line react/prop-types
                        initialValues={(draftData && draftData.data) || {}}
                    />
                );
            },
            name: 'Merchant Docs',
            sectionType: 'kycSection',
            path: `${isViewMode ? baseUrlView : baseUrlEdit}kyc/${merchantId}`,
            previousPath: `${
                isViewMode ? baseUrlView : baseUrlEdit
            }surcharge/${merchantId}`,
            status: 'Complete',
            nextPath: `${
                isViewMode ? baseUrlView : baseUrlEdit
            }pg-conf/${merchantId}`,
            tabId: 6,
            permission: 'edit_kyc,view_kyc,kyc',
        },
        {
            component(props) {
                // eslint-disable-next-line react/prop-types
                const { draftData } = props;
                return (
                    <PGConfigTab
                        isEditMode={!isViewMode}
                        isViewMode={isViewMode}
                        {...props} // eslint-disable-next-line react/prop-types
                        initialValues={(draftData && draftData.data) || {}}
                    />
                );
            },
            name: 'PG Configuration',
            sectionType: 'pgConfigurationSection',
            path: `${
                isViewMode ? baseUrlView : baseUrlEdit
            }pg-conf/${merchantId}`,
            previousPath: `${
                isViewMode ? baseUrlView : baseUrlEdit
            }kyc/${merchantId}`,
            status: 'Complete',
            nextPath: `${
                isViewMode ? baseUrlView : baseUrlEdit
            }routing/${merchantId}`,
            tabId: 7,
            permission: 'edit_pg_configuration,view_pg_configuration,pg_configuration',
        },
        {
            component(props) {
                // eslint-disable-next-line react/prop-types
                const { draftData } = props;
                return (
                    <RoutingTab
                        isEditMode={!isViewMode}
                        isViewMode={isViewMode}
                        {...props} // eslint-disable-next-line react/prop-types
                        initialValues={(draftData && draftData.data) || {}}
                    />
                );
            },
            name: 'Routing',
            sectionType: 'dynamicRoutingSection',
            path: `${
                isViewMode ? baseUrlView : baseUrlEdit
            }routing/${merchantId}`,
            previousPath: `${
                isViewMode ? baseUrlView : baseUrlEdit
            }pg-conf/${merchantId}`,
            status: 'Complete',
            nextPath: `${
                isViewMode ? baseUrlView : baseUrlEdit
            }notification/${merchantId}`,
            tabId: 8,
            permission: 'edit_dynamic_routing,view_dynamic_routing,dynamic_routing',
        },

        {
            component(props) {
                // eslint-disable-next-line react/prop-types
                const { draftData } = props;
                return (
                    <NotificationTab
                        isEditMode={!isViewMode}
                        isViewMode={isViewMode}
                        {...props} // eslint-disable-next-line react/prop-types
                        initialValues={(draftData && draftData.data) || {}}
                    />
                );
            },
            name: 'Notification',
            sectionType: 'notificationSection',
            path: `${
                isViewMode ? baseUrlView : baseUrlEdit
            }notification/${merchantId}`,
            previousPath: `${
                isViewMode ? baseUrlView : baseUrlEdit
            }routing/${merchantId}`,
            status: 'Complete',
            nextPath: null,
            tabId: 9,
            permission: 'edit_notification,view_notification,notification',
        },
    ];

    const sortedField = orderBy(fields, ['order'], ['asc']).filter(
        field => field.mandatory
    );

    if (
        merchantOnboardingPermissions &&
        merchantOnboardingPermissions.length > 0
    ) {
        let sortedFieldMapped = sortedField.map((item, index) => {
            const sectionData = processStepsList.find(
                section => section.sectionType === item.sectionType
            );
            if (
                sectionData &&(sectionData.permission.split(",").filter(item=>merchantOnboardingPermissions?.includes(item)).length)
            ) {
                if (sectionData.sectionType === item.sectionType) {
                    const previousIndex = index - 1;
                    const nextIndex = index + 1;
                    if (previousIndex >= 0) {
                        const previousSectionData =
                            processStepsList[previousIndex];
                        sectionData.previousPath = previousSectionData.path;
                    } else {
                        sectionData.nextPath = null;
                    }
                    if (nextIndex < sortedField.length && nextIndex >= 0) {
                        const nextSectionData = processStepsList[nextIndex];
                        sectionData.nextPath = nextSectionData.path;
                    } else {
                        sectionData.nextPath = null;
                    }
                }
                return { ...item, ...sectionData };
            }
        });

        sortedFieldMapped = sortedFieldMapped.filter(function(element) {
            return element !== undefined;
        });

        if (sortedFieldMapped && sortedFieldMapped.length > 0) {
            sortedFieldMapped[sortedFieldMapped.length - 1].nextPath = null;
        }

        return sortedFieldMapped;
    }
    return [];
};
